import { Entity, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';
import EpisodicChangeBase from '../episodic-change-base.entity';
import HaChange from '../ha-changes/ha-change.entity';

@Entity('episodic_ha_changes')
export default class EpisodicHaChange extends EpisodicChangeBase {
	static tableName = 'episodic_ha_changes';

	@OneToMany((type) => HaChange, (haChange) => haChange.episodicHaChange)
	haChanges: HaChange[];

	static rules() {
		return {
			...EpisodicChangeBase.rules(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
		};
	}

	assign(props?: GenPartial<EpisodicHaChange>) {
		super.assign(props);
	}

	constructor(props?: GenPartial<EpisodicHaChange>) {
		super(props);
	}
}
